<template>
  <div class="mb-2 flex items-start justify-between gap-4">
    <h2 class="text-t4">{{ title }}</h2>
    <template v-if="editable">
      <Button v-if="editing" variant="text" class="shrink-0" @click="$emit('cancel')">
        Avbryt ändringar
        <template #icon-after><IconClose /></template>
      </Button>
      <Button v-else variant="text" class="shrink-0" :disabled="disabled" @click="$emit('edit')">
        Ändra
        <template #icon-after><IconPen :class="{ 'opacity-50 grayscale': disabled }" /></template>
      </Button>
    </template>
  </div>
</template>

<script>
import Button from '@/components/ui/button';
import IconClose from '@/components/icons/IconClose';
import IconPen from '@/components/icons/IconPen';

/**
 * Rubrik för en sektion på profilsidan med "Ändra"/"Avbryt ändringar".
 * disabled används när en annan sektion redigeras.
 */
export default {
  name: 'ProfileSectionHeader',
  components: { Button, IconClose, IconPen },
  props: {
    title: { type: String, required: true },
    editable: { type: Boolean, default: true },
    editing: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ['edit', 'cancel'],
};
</script>
